import {IHttpClient} from "../..";
import {PagedResultSet} from "../../../models/api/common";
import APIBase from "../APIBase";
import PagedFilterBase from "../../../filters/PagedFilterBase";
import InvoiceModel from "../../../models/api/admin/invoices/InvoiceModel"
import InvoiceSearchResponse from "../../../models/api/invoices/BusinessBranchSearchResponse";
import InvoiceFilter from "../../../filters/InvoiceFilter";
import SignupCheckoutRequest from "../../../models/api/signup/SignupCheckoutRequest";

class InvoiceAPI extends APIBase {
    constructor(httpClient: IHttpClient) {
        super(httpClient);
    }

    GetAllInvoices(filter: InvoiceFilter): Promise<InvoiceSearchResponse> {
        return this.GET({
            Path: `/invoices/all`,
            QueryParams: filter.ToQueryParams()
        })
    }

    GetInvoicesForBranch(filter: InvoiceFilter, id: string): Promise<InvoiceSearchResponse> {
        return this.GET({
            Path: `/invoices/${id}`,
            QueryParams: filter.ToQueryParams()
        })
    }

    DownloadInvoice(invoiceId: string): Promise<Blob> {
        return this.GET({
            Path: `/invoices/download/${invoiceId}`,
        })
    }

    CheckoutGenerateInvoice(bbid: string, request: SignupCheckoutRequest): Promise<Blob> {
        return this.POST({
            Path: `/invoices/generate/${bbid}`,
            Body: request
        })
    }

    CheckoutGenerateAndEmailInvoice(bbid: string, request: SignupCheckoutRequest): Promise<boolean> {
        return this.POST({
            Path: `/invoices/generate/email/${bbid}`,
            Body: request
        })
    }

    CheckoutGenerateReceipt(bbid: string, request: SignupCheckoutRequest): Promise<Blob> {
        return this.POST({
            Path: `/invoices/generate/receipt/${bbid}`,
            Body: request
        })
    }
}

export default InvoiceAPI
